$(document).ready(function() {
  /* powercut page js start */
     //  $('.cut-sub-content').find('.btn').on("click", function(e) {
     //  e.preventDefault();
     //  var gettarget = $($(this).attr('href'));
     //  if(gettarget.length){
     //  var scrollTo = gettarget.offset().top;
     //  $('body, html').animate({scrollTop: scrollTo+'px'},1000);
     //  }
     // });
 /* powercut page js end */

 /* collection category js start */
     $('.ctm-collapsible-btn').on("click", function(){
      var triggerbtn = $(this).find('.collapsible-trigger__icon');
      triggerbtn.toggleClass('collapsible-trigger-down');
      $('.ctm-collapsible-content__inner').toggleClass('content-hide');
       
     });
 /* collection category js end */

 /* product page tab js start */ 
  //    $('.nav-tabs > li > a').on("click", function(event){
		// event.preventDefault();
		// var tag_get = $('.nav-tabs > li.active > a').attr('href');
  //       //alert(tag_get);
		// var active_set = $('.nav-tabs > li.active');
		// active_set.removeClass('active');		
		// $(this).parents('li').addClass('active');
		// $(tag_get).removeClass('active');
		// $(tag_get).addClass('itg_hide');
		// var tab_select = $(this).attr('href');
		// $(tab_select).removeClass('itg_hide');
		// $(tab_select).addClass('active');
  //   });

     $(document).on('click','.prod-tab', function(e){ 
   e.preventDefault();
   var tag_get = $(this).attr('data-id');
     $('.prod-tab').removeClass("active");
     $(this).addClass("active");
    if($('.'+tag_get).hasClass("active")){
     $('.'+tag_get).removeClass("active");
     $('.tab-content').removeClass('itg_hide');
    } else {
      $('.tab-content').removeClass("active");
      $('.tab-content').addClass('itg_hide');
      $('.'+tag_get).addClass("active"); 
    }
   });






  
 /* product page tab js end */

 /* where to shop page js start */ 
  
   $(document).on('click','.itg_btn_text',function(){
  //alert();
  var get = $(this).attr('data-get');  
  //alert(get);
  $('.popup_body').each(function() {
  var set = $(this).attr('data-get'); 
  //alert(set);
  if (get == set){
    $(this).addClass("active").siblings().removeClass("active");
    $('.popup_body.active').fadeIn();
    $('body').addClass("popup_main");
  }
  });  
  });
    
  $(document).on('click','.popup_close',function(){
  $('.popup_body').removeClass("active");
  $('.popup_body.active').fadeOut();  
  $('body').removeClass("popup_main");
  }); 

   $(document).on('click','.popup_back',function(){
   $('.popup_body').removeClass("active");
   $('body').removeClass("popup_main"); 
  });
    
  if ($(window).width() < 500){
    $(".btn-slider").slick({
    dots: false,
    infinite: true,
    loop: false,
    autoplay: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplaySpeed:5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:'<svg class="slick-button-icon slick-previous" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" fill="#fff"></path></svg></button>',
    nextArrow:'<svg class="slick-button-icon slick-next" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180)" fill="#fff"></path></svg>'  
    });
  }

  /* where to shop page js end */ 

  /* featured_specs js start */
  $(document).on('click','.featured-collapsible-trigger',function(){
    var acc_id = $(this).attr('data-id');
    //alert(acc_title); 
    //$('.featured-collapsible-content').removeClass("active");
    //$('#'+acc_id).toggleClass("active");
    $(this).find('.featured_icon').addClass('open');
    if($('#'+acc_id).hasClass("active")){
     $('#'+acc_id).removeClass("active");
    $(this).find('.featured_icon').removeClass('open');
    } else {
      $('.featured-collapsible-content').removeClass("active");
      $('#'+acc_id).addClass("active"); 
    }
  });
  
  /* featured_specs js end */

 /* collection list slider js start */

    $(".category-slider").slick({
     dots: false,
     infinite: true,
     loop: false,
     autoplay: false,    
     pauseOnHover: false,
     pauseOnFocus: false,
     autoplaySpeed:5000,
     slidesToShow: 5,
     slidesToScroll: 1,
     arrows: true,
     prevArrow:'<button class="flickity-button flickity-prev-next-button flickity-previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
     nextArrow:'<button class="flickity-button flickity-prev-next-button flickity-next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',  
     responsive: [
       {
        breakpoint: 1024,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 4,
          slidesToScroll: 1
        }
       },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 475,
        settings: {
         arrows: false,
         dots: true,
         slidesToShow: 1,
         slidesToScroll: 1
        }
      }
    ] 
    });

  $(".oregon_grid_slider").slick({
     dots: false,
     infinite: true,
     loop: false,
     autoplay: false,    
     pauseOnHover: false,
     pauseOnFocus: false,
     autoplaySpeed:5000,
     slidesToShow: 4,
     slidesToScroll: 1,
     arrows: true,
     prevArrow:'<button class="flickity-button flickity-prev-next-button flickity-previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
     nextArrow:'<button class="flickity-button flickity-prev-next-button flickity-next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',  
     responsive: [
       {
        breakpoint: 1199,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 4,
          slidesToScroll: 1
        }
       },
       {
        breakpoint: 1024,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1
        }
       },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 475,
        settings: {
         arrows: false,
         dots: true,
         slidesToShow: 1,
         slidesToScroll: 1
        }
      }
    ] 
    });


 /* collection list slider js end */ 
  

  $(document).on('click', '.footer__social a#VimeoCustomEvent', function(e) { 
    e.preventDefault(); 
    var url = $(this).attr('data-href'); 
    setTimeout (function() {
      //alert();
      window.open(url, '_blank');
    },400);
   
});

   $("#tab1").click(function() {
    $("#tab-content-1").fadeIn(500);
  });
  $("#cross1").click(function() {
    $("#tab-content-1").fadeOut(500);
  });

  $("#tab2").click(function() {
    $("#tab-content-2").fadeIn(500);
  });
  $("#cross2").click(function() {
    $("#tab-content-2").fadeOut(500);
  });

  $("#tab3").click(function() {
    $("#tab-content-3").fadeIn(500);
  });
  $("#cross3").click(function() {
    $("#tab-content-3").fadeOut(500);
  });

  $("#tab4").click(function() {
    $("#tab-content-4").fadeIn(500);
  });
  $("#cross4").click(function() {
    $("#tab-content-4").fadeOut(500);
  });

  //   $(document).on('click',".tab1", function() {
  //     $(".tab-content-1").fadeIn(500);
  // });
  // $(document).on('click',".cross1", function() {
  //     $(".tab-content-1").fadeOut(500);
  // });

  // $(document).on('click',".tab2", function() {
  //     $(".tab-content-2").fadeIn(500);
  // });
  // $(document).on('click',".cross2", function() {
  //     $(".tab-content-2").fadeOut(500);
  // });

  // $(document).on('click',".tab3", function() {
  //     $(".tab-content-3").fadeIn(500);
  // });
  // $(document).on('click',".cross3", function() {
  //     $(".tab-content-3").fadeOut(500);
  // });

  // $(document).on('click',".tab4", function() {
  //     $(".tab-content-4").fadeIn(500);
  // });
  // $(document).on('click',".cross4", function() {
  //     $(".tab-content-4").fadeOut(500);
  // });


      // open the PDF popup
        
       //    $(document).on('click',".download-pdf", function(e) {
       //      e.preventDefault(); // Prevent the default action of the link
       //      var fileUrl = $(this).data("file-url"); // Get the PDF URL from the data attribute
       //      $(".pdf-iframe").attr("src", fileUrl); // Set the src attribute of the iframe to the PDF URL
       //      $(".pdf-popup").show(); // Show the popup
       //  });

       //  // close the PDF popup
       // $(document).on('click',".close-popup", function(e) {
       //      e.preventDefault(); // Prevent the default action of the link
       //      $(".pdf-popup").hide(); // Hide the popup
       //  });


  

});  